export default __webpack_public_path__ + "images/eaea2108ee89ae56725a20644d909c3b-bridal_small.webp";